<template>
  <div class="community">
    <!-- <communityHeader></communityHeader> -->
    <router-view></router-view>
    <communityFoot></communityFoot>
  </div>
</template>
<script>
import communityHeader from '@/components/community/common/communityHeader.vue'
import communityFoot from '@/components/community/common/communityFoot.vue'
export default {
  name: "community",
  components: {
    // communityHeader, 
    communityFoot
  }
} 
</script>
<style lang="scss" scoped="scoped">
</style>



// WEBPACK FOOTER //
// src/views/community/community.vue